import colorAxisFlu from './../Flu/colorAxisFluIndex8Level'
import colorAxisCovid from './../CovidPharma/colorAxis8Level'
import colorAxisRSV from './../RSVDashboard/colorAxis8Level'
import colorAxisVul from './../VulnerabilityDashboard/colorAxisVulnerabilityIndex'
import colorAxisAllergy from './../AllergiesDashboard/colorAxisAllergiesIndex'


const dataDisplayOptions = [
  {
    label: 'Public Indicators',
    options: [
       {
        value: 'forecast_level',
        tagKey: 'forecast_level',
        tagValue: 'data_value',
        label: 'Incidense Rate',
        colorAxis: colorAxisRSV,
        mapTitle: 'US RSV Incidence',
        indicatorName: 'Forecasts',
        mapSubTitle: undefined,
        legend: {
          enabled: false,
          title: {
            text: 'US RSV Incidence',
          },
        },
      },
      {
        value: 'threshold_level',
        tagKey: 'threshold_level',
        tagValue: 'vulnrebility_index',
        label: 'Vulnrebility Index',
        colorAxis: colorAxisVul,
        mapTitle: 'US Vulnrebility Index',
        mapSubTitle: undefined,
        indicatorName: 'Vulnrability',
        legend: {
          enabled: false,
          title: {
            text: 'US Vulnrebility Index',
          },
        },
      },
       {

        value: 'threshold_level',
        tagKey: 'threshold_level',
        tagValue: 'data_value',
        label: 'Air Quality Count',
        colorAxis: colorAxisAllergy,
        mapTitle: '',
        mapSubTitle: undefined,
        indicatorName: 'Actuals',
        legend: {
          enabled: false,
          title: {
            text: '',
          },
        },
      },
      {
        value: 'forecast_level',
        tagKey: 'forecast_level',
        tagValue: 'data_value',
        label: 'Incidense Rate',
        colorAxis: colorAxisFlu,
        mapTitle: 'US RSV Incidence',
        mapSubTitle: undefined,
        legend: {
          enabled: false,
          title: {
            text: 'US RSV Incidence',
          },
        },
      },
       {
        value: 'forecast_level',
        tagKey: 'forecast_level',
        tagValue: 'data_value',
        label: 'Incidense Rate',
        colorAxis: colorAxisCovid,
        mapTitle: 'US Covid Incidence',
        mapSubTitle: undefined,
        legend: {
          enabled: false,
          title: {
            text: 'US Covid Incidence',
          },
        },
      },
    ],
  },
]

export default dataDisplayOptions
